import styled from 'styled-components';

export const CardsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin: 24px 0;
`;

export const Card = styled.div<{ color: string }>`
  flex: 1;
  background-color: ${({ color }) => color};
  color: white;
  border-radius: 6px;
  padding: 16px;
  text-align: center;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

export const Value = styled.div`
  font-size: 24px;
  font-weight: bold;
`;
